import { ref } from 'vue'
import { defineStore } from 'pinia'
import { myRequest } from '@/utils/fetch'

type profileResponse = {
  user: {
    email: string
    userID: number
    picture: string
    lastName: string
    provider: string
    createdAt: string
    firstName: string
    updatedAt: string
    howDidYouHear: string
    subscriptionID: string
    lastViewedUpdates: string
  }
  settings: {
    enrichmentFilters: {
      currentPosition: boolean
      jobHistory: boolean
      education: boolean
      companyOverview: boolean
      companyNews: boolean
      companyFunding: boolean
      weather: boolean
      talkingPoints: boolean
      location: boolean
    }
    settingID: number
    emailDelivery: boolean
    calendarDelivery: boolean
    notifyAt: string
    notifyBefore: number
    lastMetWith: number
    deliveryRule: string
    createdAt: string
    updatedAt: string
    userID: number
  }
}

const STORE_NAME = 'auth'

export const useAuthStore = defineStore(STORE_NAME, () => {
  const localStoreageVal = localStorage.getItem(STORE_NAME)
  const user = ref<profileResponse['user'] | null>(localStoreageVal ? JSON.parse(localStoreageVal).user : null)
  const settings = ref<profileResponse['settings'] | null>(
    localStoreageVal ? JSON.parse(localStoreageVal).settings : null
  )
  const isAuthenticated = ref(user.value !== null)

  const authenticate = (profile: profileResponse) => {
    localStorage.setItem(STORE_NAME, JSON.stringify(profile))
    user.value = profile.user
    settings.value = profile.settings
    isAuthenticated.value = true
  }
  const logout = async () => {
    await myRequest('POST', 'auth/logout')
    localStorage.removeItem(STORE_NAME)
    isAuthenticated.value = false
    settings.value = null
    user.value = null
  }

  const checkWithServer = async () => {
    try {
      const profile = (await myRequest('GET', 'user/me')) as profileResponse
      if (profile?.user) {
        authenticate(profile)
        return profile
      }
      return null
    } catch (error) {
      logout()
      return null
    }
  }
  return { isAuthenticated, user, settings, authenticate, logout, checkWithServer }
})
